edit.classy.controller({
    name: 'EditController',
    inject: ['$scope', 'ApplicationSideBarService', 'AskSchoolSpecificQuestionsModelService', 'FamilyModelService', 'ApplicationService', 'SchoolModelService',
        'CalculationService', 'AlertService', '$sce', '$modal', '$q', 'MedianExpenseModelService', 'authServiceFactory', 'SliderService', 'SliderFactory'],
    init: function()
    {
        this.$.ApplicationSideBarService = this.ApplicationSideBarService;
        this.$.ApplicationService = this.ApplicationService;
        this.$.CalculationService = this.CalculationService;
        this.$.AlertService = this.AlertService;
        this.$.versionNo = versionNo;
        this.$.$sce = this.$sce;
        this.$.schoolinfo = this.SchoolModelService.get()[0];
        this.$.newLetter = 0;
        this.$.familyLetter = '';
        this.$.questions = this.AskSchoolSpecificQuestionsModelService.get();
        this.$.names = [];
        this.$.names.applicants = [];
        this.$.names.children = [];
        this.$.names.dependants = [];
        this.$.names.parents = [];
        this.$.SliderService = this.SliderService;
        for (var i = 0; i < this.ApplicationService.getAwardData().applicants.length; i++) {
            this.$.names.applicants.push(this.ApplicationService.getAwardData().applicants[i].App_First);
        }
        for (var j = 0; j < this.ApplicationService.getAwardData().family[0].children.length; j++) {
            this.$.names.children.push(this.ApplicationService.getAwardData().family[0].children[j].Chi_First_Name)
        }
        for (var k = 0; k < this.ApplicationService.getAwardData().family[0].dependant.length; k++) {
            this.$.names.dependants.push(this.ApplicationService.getAwardData().family[0].dependant[k].Dep_First_Name)
        }
        for (var m = 0; m < this.ApplicationService.getAwardData().family[0].data.length; m++) {
            this.$.names.parents.push(this.ApplicationService.getAwardData().family[0].data[m].Fam_Name_First)
        }
        /*
        this.$.median = this.getMedianExpense(this.$.medianChoice);
        this.$.medianChoice = {};
        this.$.medianChoices = [
            { id: this.authServiceFactory.getAuth().schoolID, name: "School" },
            { id: this.SchoolModelService.get()[0].School_Zip.toString().substr(0, 5) + "-1", name: "Zip-1" },
            { id: this.SchoolModelService.get()[0].School_Zip.toString().substr(0, 5) + "-2", name: "Zip-2" },
            { id: this.SchoolModelService.get()[0].School_Zip.toString().substr(0, 5) + "-3", name: "Zip-3" },
            { id: this.SchoolModelService.get()[0].School_Zip.toString().substr(0, 5) + "-4", name: "Zip-4" },
            { id: this.SchoolModelService.get()[0].School_Zip.toString().substr(0, 5) + "-5", name: "Zip-5" },
            { id: this.SchoolModelService.get()[0].School_Zip.toString().substr(0, 5) + "-10", name: "Zip-10" },
            { id: this.SchoolModelService.get()[0].School_Zip.toString().substr(0, 5) + "-25", name: "Zip-25" },
            { id: this.SchoolModelService.get()[0].School_Zip.toString().substr(0, 5) + "-50", name: "Zip-50" },
            { id: this.SchoolModelService.get()[0].School_State, name: "State" }
        ]
        this.$.medianChoice.choice = this.$.medianChoices[0].name;
        */
        
    },
    conversion: function() {
        this.$.familyLetter.replace()
    },
    formatAnswer: function(question)
    {
        //Move this to the backend
        var temp;
        var answer = question.Answer;
        if (question.Q_type == 2)
        {
            temp = question.Answer.split("|");
            temp[0] = temp[0].replaceAll(",");
            temp[0] = temp[0].addCommas();
            if (question.money==1)
                temp[0] = "$" + temp[0];
            if (temp[1]!=='#')
                answer = temp[0] + " - " + temp[1];
            else
                answer = temp[0];
        }
        return answer.toString();
    },
    printList: function() {
        var mywindow = window.open('', 'my div', 'height=400,width=800');
        mywindow.document.write('<html><head><title>my div</title>');
        mywindow.document.write('</head><body >');
        mywindow.document.write($('#letterHtml').html());
        mywindow.document.write('</body></html>');
        mywindow.document.close(); // necessary for IE >= 10
        mywindow.focus(); // necessary for IE >= 10
        mywindow.print();
        mywindow.close();
        return true;
    },
    addLetter: function()
    {
        this.$.newLetter = !this.$.newLetter;
    },
    saveLetter: function()
    {
        this.$.putObject = this.FamilyModelService.get();
        var queue = [];
        var deferred = this.$q.defer();
        for (var i = 0; i < this.$.putObject.length; i++) {
            this.$.familyLetter = $('#familyLetter').redactor('code.get');
            this.$.putObject[i].Fam_Letter = this.$.familyLetter;
            queue.push(this.FamilyModelService.put(this.$.putObject[i].recordID, this.$.putObject[i]));
        }
        this.$q.all([queue]).then(function (results) {
            deferred.resolve(results);
        });
        return deferred.promise;
    },
    getFamilyNo: function()
    {
        return parseInt(this.ApplicationService.getFamilyNo()) + 1;
    },
    openFamilyPDF: function()
    {
        var familyID = this.$.ApplicationService.getFamilyID();
        let domain = this.authServiceFactory.getDomain();
        var url = "https://" + domain + "//family_side/faAppPdf.php?familyID=" + familyID;
        var win = window.open(url, '_blank');
        win.focus();
    },
    getMedianExpense: function(key)
    {
        for (var i = 0; i < this.MedianExpenseModelService.get().length; i++)
        {
            if (this.MedianExpenseModelService.get()[i].pKey == key)
                return this.MedianExpenseModelService.get()[i];
        }
    },
    medianDropDownChange: function(value)
    {
        this.$.median = this.getMedianExpense(value.id);
    },
    setPartial: function(partial, header, params)
    {
        if (params!==undefined) {
            if (params.type!==undefined) {
                if (params.type == 'c' && this.ApplicationService.getFamilyData().children.length==0)
                    params = {type:'d','tab':0};
                
                if (params.type == 'd' && this.ApplicationService.getFamilyData().dependant.length==0)
                    params = null;
            }
        }
        this.SliderService.pushSlider(new this.SliderFactory(partial, header, 's', params));
    }

});

stateProviders.push({
    name: 'schoolside.application.edit',
    url: '/edit',
    templateUrl: 'fast/submodules/schoolside/applications/submodules/tabs/edit/partials/edit.html?v=' + versionNo,
    controller: 'EditController'
});


/* End accountInfo Module */
